import { head, isEmpty, get } from 'lodash';
import helper from './helper';

export default (xScale, mouseEvents, isPrambanan) => (selection) => {
  const data = head(selection.data());
  const { origin } = data;
  let { destinations } = data;
  const { onDropClick, onDropMouseover, onDropMouseout } = mouseEvents;
  const { inRange } = helper;
  const domain = xScale.domain();

  selection.selectAll('.drops').remove();

  const drops = selection.selectAll('.drops').data(d => Array(d));
  const gDrops = drops
    .enter()
    .append('g')
    .classed('drops', true);

  destinations = destinations.map((dest) => {
    dest.sequence = get(dest, 'orders.0.sequence');
    return dest;
  });

  const greenColor = '#73D216';
  const blueColor = '#46A8F6';
  const redColor = '#f86c6b';
  const yellowColor = '#EDD400';
  const highlightOutlineColor = '#000000';
  const defineDropColor = (destinationData) => {
    const { orders = [], finish } = destinationData;
    const orderStatuses = orders.map(order => order.status);
    const hasCancelledOrder = orderStatuses.includes('CANCELLED') || orderStatuses.includes('REJECTED');
    let definedColor = blueColor;

    if (finish && !hasCancelledOrder) {
      definedColor = isPrambanan ? yellowColor : greenColor;
    } else if (finish && hasCancelledOrder) {
      definedColor = redColor;
    }

    return definedColor;
  };

  const originDrop = gDrops.selectAll('.drop__origin').data([origin]);
  originDrop
    .enter()
    .append('circle')
    .classed('drop', true)
    .classed('drop__origin', true)
    .style('cursor', 'pointer')
    .on('mouseover', onDropMouseover('origin'))
    .on('mouseout', onDropMouseout())
    .attr('fill', () => {
      const completedColor = isPrambanan ? yellowColor : greenColor;
      const dropColor = data.total_percentage > 0 ? completedColor : blueColor;
      return domain[0] > 0 ? 'transparent' : dropColor;
    })
    .style('pointer-events', () => (domain[0] > 0 ? 'none' : 'auto'))
    .attr('r', 5)
    .attr('cy', 37.5)
    .attr('cx', xScale(0));

  let distanceCalc = 0;
  let distanceSummary = 0;
  let distanceCalcFill = 0;
  // const ordered = orderBy(destinations, ['sequence'], ['asc']);
  const destinationDrops = gDrops.selectAll('.drop__destination').data(destinations);
  destinationDrops
    .enter()
    .append('circle')
    .classed('drop', true)
    .classed('drop__destination', true)
    .on('click', onDropClick('destination'))
    .on('mouseover', onDropMouseover('destination'))
    .on('mouseout', onDropMouseout())
    .style('cursor', 'pointer')
    .attr('fill', (d) => {
      const dropFillColor = defineDropColor(d);
      distanceCalc += !isEmpty(d.direction) ? d.direction.distance : 0;
      return inRange(distanceCalc, domain[0], domain[1])
        ? dropFillColor : 'transparent';
    })
    .attr('stroke', d => (d.highlight === 1 ? highlightOutlineColor : 'none'))
    .attr('strokeWidth', d => (d.highlight === 1 ? 5 : 0))
    .style('pointer-events', (d) => {
      distanceCalcFill += !isEmpty(d.direction) ? d.direction.distance : 0;
      return inRange(distanceCalcFill, domain[0], domain[1]) ? 'auto' : 'none';
    })
    .attr('r', d => (d.highlight === 1 ? 8 : 5))
    .attr('cy', 37.5)
    .attr('cx', (d) => {
      distanceSummary += !isEmpty(d.direction) ? d.direction.distance : 0;
      return xScale(distanceSummary);
    });

  return drops;
};



// WEBPACK FOOTER //
// ./src/views/pages/completion/drops.js